/**
 * Gating helpers deciding when a `forexPositionsCount` COUNT query is worth
 * firing. Each Forex positions COUNT is slow on MT5 (closed-count runs a big
 * aggregate), so we only fetch the one the currently active tab actually reads
 * instead of fetching all of them on every mount.
 */

export type PositionsTab = 'open' | 'closed' | 'pending'

/** The closed count only drives the closed tab (empty-state + paginator). */
export const shouldFetchClosedPositionsCount = (status: PositionsTab): boolean =>
  status === 'closed'

/** The paginator `count` is only rendered when pagination is enabled. */
export const shouldFetchPaginatorPositionsCount = (enablePagination?: boolean): boolean =>
  Boolean(enablePagination)
